import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../services/projects/projects.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { MatDialog } from "@angular/material";
import { LayoutDialogComponent } from "../layout-dialog/layout-dialog.component";

@Component({
  selector: "app-build",
  templateUrl: "./build.component.html",
  styleUrls: ["./build.component.css"],
})
export class BuildComponent implements OnInit {
  @ViewChild('container') containerRef!: ElementRef;
  project_id: string;
  project: any = [];
  projectBuldings: any;
  buildingDetailsForms: any = [];
  active: number = null;
  availableCount: number = 0;
  reservedCount: number = 0;
  activeProject: any = null;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));

  constructor(
    private projectService: ProjectsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.project_id = params["id"];
      this.project_id && this.getcurrentproject(this.project_id);
      this.project_id && this.getProjectBuilding(this.project_id);
    });
  }

  getcurrentproject(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getcurrentproject(project_id).subscribe(
      (data) => {
        this.project = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getProjectBuilding(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getProjectBuilding(project_id).subscribe(
      (data: any) => {
        let status = [];
        data.map((building) => {
          Object.keys(building.status_counts).map((key) => {
            status.push({
              name: key,
              count: building.status_counts[key],
            });
          });
          building.status_counts = status;
          status = [];
        });
        this.projectBuldings = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getBuildingDetails(building_name, activeProject, index) {
    this.active = index;
    this.activeProject = activeProject;
    this.assignAvailableCount(activeProject);
    this.assignReservedCount(activeProject);
    this.slimLoadingBarService.start();
    const qParams: any = {};
    if (activeProject && activeProject.location) {
      qParams.location = activeProject.location;
    }
    this.projectService
      .getBuildingDetails(this.project_id, building_name, qParams)
      .subscribe(
        (res: any) => {
          this.buildingDetailsForms = res.data;
          setTimeout(() => {
            if (this.containerRef) {
              this.containerRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
            }
          });
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  assignAvailableCount(project) {
    this.availableCount = 0;
    project.status_counts.map((key) => {
      if (key.name === "Available") {
        this.availableCount = key.count;
      }
    });
  }

  assignReservedCount(project) {
    this.reservedCount = 0;
    project.status_counts.map((key) => {
      if (key.name === "Reserved") {
        this.reservedCount = key.count;
      }
    });
  }

  viewUnitDetails(unit_id) {
    this.router.navigate(["./pages/projects/view-unit"], {
      queryParams: {
        project_id: this.project_id,
        unit_id: unit_id,
      },
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "Available":
        return "available";
      case "Temp Blocked":
        return "temp-blocked";
      case "Blocked":
         return "blocked";
      case "Not Available":
        return "not-available";
      case "Re-pricing":
        return "re-pricing";
      default:
        return "reserved";
    }
  }

  openLayoutDialog(unit: any) {
    this.dialog.open(LayoutDialogComponent, {
      width: "80vw",
      height: "95vh",
      data : unit
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/build/build.component.ts